import Localization from 'lib/localization';

export default {
    lxPlaceholderTitle() {
        return Localization.get('badoo_safety_center@search_field.placeholder.title');
    },
    lxSearchA11yLabel() {
        return Localization.get('badoo_safety_center@search_field.submit.a11y.label');
    },
    lxClearSearchA11yLabel() {
        return Localization.get('badoo_safety_center@search_field.clear.a11y.label');
    },
};
